import type { HomeDto } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import dayjs from 'dayjs'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { YEAR_FIRST_DATE_FORMAT } from '../utils.datetime'

export const ROTA_OVERVIEW_URL = 'rota-reporting/overview'
export const ROTA_OVERVIEW_QUERY_KEY = 'rota-overview'

export type RotaOverviewFilters = {
  from?: Date
  to?: Date
  teamMembers?: string[]
  contractTypes?: string[]
  eventTypes?: string[]
}

export const useRotaOverview = (filters: RotaOverviewFilters) => {
  const home = useSelector(
    (state: { global: { home: HomeDto } }) => state.global.home
  )

  const queryParams = new URLSearchParams()

  if (filters.from) {
    queryParams.append(
      'from',
      dayjs(filters.from).format(YEAR_FIRST_DATE_FORMAT)
    )
  }

  if (filters.to) {
    queryParams.append('to', dayjs(filters.to).format(YEAR_FIRST_DATE_FORMAT))
  }

  filters.teamMembers?.forEach((teamMember) => {
    queryParams.append('teamMembers[]', teamMember)
  })

  filters.contractTypes?.forEach((contractType) => {
    queryParams.append('contractTypes[]', contractType)
  })

  queryParams.append('homeId', home.id)

  const { data, isLoading, error } = useQuery(
    [ROTA_OVERVIEW_QUERY_KEY, filters, home.id],
    () =>
      getJSON({
        url: `${ROTA_OVERVIEW_URL}?${queryParams}`,
        isRota: true
      }),
    {
      enabled: Boolean(filters.from && filters.to && home.id)
    }
  )

  return {
    overview: data,
    isLoading,
    error
  }
}
